// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__1NreD","title":"AfterFrontImage_title__3x46i"};